import { render } from "./PageUpdateDataWawancaraNew.vue?vue&type=template&id=3f40780c&scoped=true"
import script from "./PageUpdateDataWawancaraNew.vue?vue&type=script&lang=js"
export * from "./PageUpdateDataWawancaraNew.vue?vue&type=script&lang=js"

import "./PageUpdateDataWawancaraNew.vue?vue&type=style&index=0&id=3f40780c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f40780c"]])

export default __exports__